import { createPostEndpoint } from '@sonar-software/sonar-http';
import { InitiativeStatus, InitiativeType } from '@types';

export type PostInitiativeRequest = {
	assignedTo: number;
	description: string;
	initiativeStatusId: InitiativeStatus;
	initiativeTypeId: InitiativeType;
	source: string;
	title: string;
};

export type PostInitiativeResponse = {
	initiativeId: number;
	initiativeTitle: string;
};

const postInitiativeBase = createPostEndpoint<PostInitiativeRequest, PostInitiativeResponse>('/api/v3/initiatives/');

export const postInitiative: typeof postInitiativeBase = async(request) => {
	const response = await postInitiativeBase(request);

	if (response.data) {
		response.data.initiativeTitle = request.title;
	}

	return response;
};
